import { useState, forwardRef } from 'react';
import { Eye, EyeOff } from 'lucide-react';

// Reusable password input with a show/hide toggle (eye icon).
// Uses forwardRef so it works cleanly with react-hook-form's register(),
// same as a plain <input> would.
//
// Usage: <PasswordInput {...register('password')} style={styles.input} />
const PasswordInput = forwardRef(({ style, ...props }, ref) => {
  const [visible, setVisible] = useState(false);

  return (
    <div style={styles.wrapper}>
      <input
        {...props}
        ref={ref}
        type={visible ? 'text' : 'password'}
        style={{ ...style, paddingRight: 40 }}
      />
      <button
        type="button"
        onClick={() => setVisible(!visible)}
        style={styles.toggleBtn}
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
      >
        {visible ? <EyeOff size={18} color="#9ca3af" /> : <Eye size={18} color="#9ca3af" />}
      </button>
    </div>
  );
});

const styles = {
  wrapper: {
    position: 'relative',
    width: '100%',
  },
  toggleBtn: {
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    padding: 4,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
};

export default PasswordInput;
